<template>
  <!-- 災害編集/追加 -->
  <div id="AppDisasterEdit">
    <!-- 余白 -->
    <div style="height: 10px" />

    <div class="columns">
      <div class="column">
        <label class="searchTitle label">災害情報管理</label>
      </div>
    </div>

    <!-- ボタン -->
    <div style="text-align: right">
      <b-button
        v-on:click="back()"
        class="button"
        type="is-primary"
        icon-left="keyboard-backspace"
        native-type="button"
      >
        戻る
      </b-button>
      <b-button
        v-if="
          positionCode == positionIdMap.gss ||
          positionCode == positionIdMap.branchMgr ||
          positionCode == positionIdMap.blockMgr ||
          positionCode == positionIdMap.gssMgr ||
          positionCode == positionIdMap.salesStrategy ||
          positionCode == positionIdMap.salesChief ||
          positionCode == positionIdMap.soc ||
          roleId == roleMap.systemManager
        "
        v-on:click="regist()"
        class="button"
        type="is-primary"
        icon-left="content-save"
        native-type="button"
      >
        登録
      </b-button>
      <b-button
        v-if="
          positionCode == positionIdMap.soc ||
          roleId == roleMap.systemManager
        "
        v-on:click="doWithdrawale()"
        class="button"
        type="is-primary"
        icon-left="select-off"
        native-type="button"
        :disabled="!data.disasterId"
      >
        削除
      </b-button>
    </div>

    <!-- 災害情報 -->
    <div style="detailArea">
      <table class="table is-full" style="width: 100%">
        <tr>
          <th style="border-bottom: solid 1px; width: 150px">登録日</th>
          <td
            v-if="
              positionCode == positionIdMap.gss ||
              positionCode == positionIdMap.branchMgr ||
              positionCode == positionIdMap.blockMgr ||
              positionCode == positionIdMap.gssMgr ||
              positionCode == positionIdMap.salesStrategy ||
              positionCode == positionIdMap.salesChief ||
              positionCode == positionIdMap.soc ||
              roleId == roleMap.systemManager
            "
            style="border-bottom: solid 1px"
            colspan="6"
          >
            <b-field
              :type="{ 'is-danger': errors.has('entryDate') }"
              :message="errors.first('entryDate')"
            >
              <b-datepicker
                v-model="data.entryDate"
                data-vv-as="登録日"
                icon="calendar-today"
                :month-names="monthNames"
                :day-names="dayNames"
                name="entryDate"
                v-validate="'required'"
                data-vv-validate-on="input"
              >
                <button class="button is-danger" @click="data.entryDate = null">
                  <b-icon icon="close"></b-icon>
                  <span>Clear</span>
                </button>
              </b-datepicker>
            </b-field>
          </td>
          <td v-else style="border-bottom: solid 1px">
            {{ formatDate2(data.entryDate) }}
          </td>
        </tr>
        <tr>
          <th style="border-bottom: solid 1px; width: 150px">支店名</th>
          <td
            v-if="
              positionCode == positionIdMap.gss ||
              positionCode == positionIdMap.branchMgr ||
              positionCode == positionIdMap.blockMgr ||
              positionCode == positionIdMap.gssMgr ||
              positionCode == positionIdMap.salesStrategy ||
              positionCode == positionIdMap.salesChief ||
              positionCode == positionIdMap.soc ||
              roleId == roleMap.systemManager
            "
            style="border-bottom: solid 1px"
            colspan="6"
          >
            <b-field
              :type="{ 'is-danger': errors.has('branchName') }"
              :message="errors.first('branchName')"
            >
              <b-select
                v-model="data.branchCode"
                name="branchName"
                data-vv-as="支店名"
                v-validate="'required'"
              >
                <option
                  v-for="branch in branchOptions"
                  :value="branch.branchCode"
                  :key="branch.branchCode"
                >
                  {{ branch.branchName }}
                </option>
              </b-select>
            </b-field>
          </td>
          <td v-else style="border-bottom: solid 1px">
            {{ branchName }}
          </td>
        </tr>
        <tr>
          <th style="border-bottom: solid 1px; width: 150px">災害名</th>
          <td
            v-if="
              positionCode == positionIdMap.gss ||
              positionCode == positionIdMap.branchMgr ||
              positionCode == positionIdMap.blockMgr ||
              positionCode == positionIdMap.gssMgr ||
              positionCode == positionIdMap.salesStrategy ||
              positionCode == positionIdMap.salesChief ||
              positionCode == positionIdMap.soc ||
              roleId == roleMap.systemManager
            "
            style="border-bottom: solid 1px"
            colspan="6"
          >
            <b-field
              :type="{ 'is-danger': errors.has('disasterName') }"
              :message="errors.first('disasterName')"
            >
              <b-input
                v-model="data.disasterName"
                name="disasterName"
                data-vv-as="災害名"
                v-validate="'required'"
                maxlength="100"
              ></b-input>
            </b-field>
          </td>
          <td v-else style="border-bottom: solid 1px">
            {{ data.disasterName }}
          </td>
        </tr>
      </table>
    </div>

    <!-- 患者一覧 -->
    <disaster-patient-list
      v-if="disasterId"
      ref="disasterPatientList"
      :disasterId="disasterId"
    />

    <!-- 下部余白 -->
    <div style="height: 10px" />
  </div>
</template>

<script>
import DisasterPatientListTemplate from "./AppDisasterPatientList";
import * as datetime from "../utils/datetime";
import * as user from "../utils/user";

export default {
  components: {
    "disaster-patient-list": DisasterPatientListTemplate,
  },

  data() {
    let disasterId = this.$route.params.disasterId;
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let positionCode = userInfo.positionCode;
    let positionIdMap = user.POSITION_ID_MAP;
    let roleId = userInfo.roleId;
    let roleMap = user.ROLE_ID_MAP;
    let data = {
      entryDate: new Date(),
      branchCode: null,
      disasterName: "",
      patientList: [],
    };

    return {
      data: data,
      disasterId: disasterId,
      monthNames: datetime.MONTHS,
      dayNames: datetime.DAYS,
      branchOptions: [],
      positionCode,
      positionIdMap,
      roleId,
      roleMap,
    };
  },

  computed: {
    branchName: function () {
      let res = "";
      let branch = this.branchOptions.find(
        (elem) => elem.branchCode == this.data.branchCode
      );
      if (branch) {
        res = branch.branchName;
      }
      return res;
    },
  },

  filters: {},

  methods: {
    getBranchesGET: function (client) {
      const apiRes = client.apis.apiMaster.getBranchesGET();
      return apiRes;
    },

    getBranchesGETsuccess(result) {
      // WebAPI応答内容を画面に設定
      this.branchOptions = result.obj;
      return;
    },

    getBranchesGETerror(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      return;
    },

    // 災害情報コードが指定されている場合（編集の場合）、災害情報を取得する。
    getDisasterPOST: function (client) {
      const apiRes = client.apis.apiDisaster.getDisasterPOST({
        disasterId: this.disasterId,
      });
      return apiRes;
    },

    getDisasterPOSTsuccess: function (result) {
      //WebAPI応答内容を画面に設定
      this.data = result.obj;
      this.data.entryDate = this.parseDate(this.data.entryDate);
      return;
    },

    getDisasterPOSTerror: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      return;
    },

    // 戻る
    back: function () {
      this.doReturn();
      return;
    },

    doReturn: function () {
      this.$router.push({
        name: "AppDisasterSearch",
        params: { searchConditions: this.$route.params.searchConditions },
      });
      return;
    },

    createRequestBody: function () {
      const body = JSON.parse(JSON.stringify(this.data));
      return body;
    },

    // 登録
    setDisasterPOST: function (client) {
      const body = this.createRequestBody();
      const apiRes = client.apis.apiDisaster.setDisasterPOST({
        body: body,
      });
      return apiRes;
    },

    setDisasterPOSTsucces: function (result) {
      this.showSuccess(result);
      this.back();
      return;
    },

    // 更新
    setDisasterPUT: function (client) {
      const body = this.createRequestBody();
      const apiRes = client.apis.apiDisaster.setDisasterPUT({
        body: body,
      });
      return apiRes;
    },

    setDisasterPUTsucces: function (result) {
      this.showSuccess(result);
      this.back();
      return;
    },

    setDisasterError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result.obj.message);
      return;
    },

    // 登録
    regist: async function () {
      const validateRes = await this.$validator.validateAll();
      if (!validateRes) {
        return;
      }

      if (this.disasterId) {
        // 更新
        // API呼び出し
        this.apiCall(
          this.setDisasterPUT,
          this.setDisasterPUTsucces,
          this.setDisasterError
        );
      } else {
        // 登録
        // API呼び出し
        this.apiCall(
          this.setDisasterPOST,
          this.setDisasterPOSTsucces,
          this.setDisasterError
        );
      }

      return;
    },

    // 削除
    doWithdrawale: async function () {
      const confiermRes = await this.showComfirmMessage(
        "この災害情報を削除します。よろしいですか？"
      );
      if (confiermRes) {
        // API呼び出し
        this.apiCall(
          this.deleteDisasterDELETE,
          this.deleteDisasterDELETEsucces,
          this.deleteDisasterDELETEerror
        );
      }
      return;
    },

    deleteDisasterDELETE: function (client) {
      const apiRes = client.apis.apiDisaster.deleteDisasterDELETE({
        disasterId: this.data.disasterId,
      });
      return apiRes;
    },

    deleteDisasterDELETEsucces: function (result) {
      this.showSuccess(result);
      this.back();
      return;
    },

    deleteDisasterDELETEerror: function (result) {
      this.showErrorMessage(result);
      return;
    },
  },

  created: async function () {
    await this.apiCall(
      this.getBranchesGET,
      this.getBranchesGETsuccess,
      this.getBranchesGETerror
    );

    if (this.disasterId) {
      this.apiCall(
        this.getDisasterPOST,
        this.getDisasterPOSTsuccess,
        this.getDisasterPOSTerror
      );
    }

    return;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AppDisasterEdit.vue